<template>
    <div>
        <div class="content" style="width: auto">
            <div class="cont-list">
                <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{ route.menuName }}</span>
            </div>

            <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
                <div class="edit-card">
                    <div style="width: 88%; display: flex">
                        <div class="start-label" />
                        <span class="text">基础信息</span>
                    </div>
                    <el-row>
                        <el-col :span="6" :class="!getIsView()?'viewCol':''">
                            <el-form-item prop="no" label="盘点单号" v-if="getIsView()">
                                <el-input disabled v-model="form.no"></el-input>
                            </el-form-item>
                            <span class="viewText" v-else>盘点单号:{{ form.no }} </span>
                        </el-col>
                        <el-col :span="6" :class="!getIsView()?'viewCol':''">
                            <el-form-item label="创建时间" prop="createdTime" v-if="getIsView()">
                                <el-date-picker v-model="form.createdTime" disabled type="datetime"
                                    placeholder="系统自动带出创建时间" style="width: 100%">
                                </el-date-picker>
                            </el-form-item>
                            <span class="viewText" v-else>创建时间:{{   parseTime(new Date(form.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }} </span>
                        </el-col>
                        <el-col :span="6" :class="!getIsView()?'viewCol':''">
                            <el-form-item prop="createdUserName" label="发起人" v-if="getIsView()">
                                <el-input disabled v-model="form.createdUserName"></el-input>
                            </el-form-item>
                            <span class="viewText" v-else>发起人:{{ form.createdUserName }} </span>
                        </el-col>
                        <el-col :span="6" :class="!getIsView()?'viewCol':''">
                            <el-form-item prop="ownerDeptName" label="所属科室" v-if="getIsView()">
                                <el-input disabled v-model="form.ownerDeptName"></el-input>
                            </el-form-item>
                            <span class="viewText" v-else>所属科室:{{ form.ownerDeptName }} </span>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="6" :class="!getIsView()?'viewCol':''">
                            <el-form-item prop="warehouseName" label="盘点仓库" v-if="getIsView()">
                                <el-select v-model="form.warehouseName" :disabled="!editMode || loading"
                                    placeholder="请选择" filterable :filter-method="getWarehousesBySessionWarehouseId"
                                    @change="warehouseChange" style="width:100%">
                                    <el-option v-for="item in STATIC_Warehouses" :key="item.id" :label="item.name"
                                        :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <span class="viewText" v-else>盘点仓库:{{ form.warehouseName }} </span>
                        </el-col>
                        <el-col :span="4" :class="!getIsView()?'viewCol':''">
                            <el-form-item prop="warehouseCategoryName" label="库房类别" v-if="getIsView()">
                                <el-input disabled v-model="form.warehouseCategoryName"></el-input>
                            </el-form-item>
                            <span class="viewText" v-else>库房类别:{{ form.warehouseCategoryName }} </span>
                        </el-col>
                        <el-col :span="4" :class="!getIsView()?'viewCol':''">
                            <el-form-item prop="date" label="盘点日期" v-if="getIsView()">
                                <el-date-picker :disabled="!editMode" v-model="form.date" size="small" type="date"
                                    format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="入库日期"
                                    style="width:100%"></el-date-picker>
                            </el-form-item>
                            <span class="viewText" v-else>盘点日期:{{  parseTime(new Date(form.date), "{y}-{m}-{d}") }} </span>
                        </el-col>
                        <el-col :span="4" :class="!getIsView()?'viewCol':''">
                            <el-form-item prop="stockCategory" label="库存类型" v-if="getIsView()">
                                <el-radio-group :disabled="!editMode || loading" v-model="form.stockCategory"
                                    @change="categoryChange">
                                    <el-radio :label="0">普通库存</el-radio>
                                    <el-radio :label="1">备货库存</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <span class="viewText" v-else>库存类型:{{ form.stockCategory==1?'备货库存':'普通库存' }} </span>
                        </el-col>
                        <el-col :span="4" :class="!getIsView()?'viewCol':''">
                            <el-form-item prop="billingLogo" label="计费标识" v-if="getIsView()">
                                <el-select v-model="form.billingLogo" :disabled="!editMode || loading" placeholder="请选择"
                                    @change="billingLogoTypeChaneg" style="width:100%">
                                    <el-option label="全部" :value="3"></el-option>
                                    <el-option label="计费" :value="1"></el-option>
                                    <el-option label="不计费" :value="0"></el-option>
                                </el-select>
                            </el-form-item>
                            <span class="viewText" v-else>计费标识:{{ form.billingLogo == 1 ? '计费' : (form.billingLogo == 0 ? '不计费' : '全部') }} </span>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="3" :class="!getIsView()?'viewCol':''">
                            <el-form-item prop="totalStockNumber" label="账面总数量" v-if="getIsView()">
                                <el-input disabled placeholder="请输入账面总数量" v-model="form.totalStockNumber"></el-input>
                            </el-form-item>
                            <span class="viewText" v-else>账面总数量:{{ form.totalStockNumber }} </span>
                        </el-col>
                        <el-col :span="3" :class="!getIsView()?'viewCol':''">
                            <el-form-item prop="totalStockAmount" label="账面总金额" v-if="getIsView()">
                                <el-input disabled placeholder="请输入账面总金额" v-model="form.totalStockAmount"></el-input>
                            </el-form-item>
                            <span class="viewText" v-else>账面总金额:{{ form.totalStockAmount }} </span>
                        </el-col>
                        <el-col :span="3" :class="!getIsView()?'viewCol':''">
                            <el-form-item prop="totalNumber" label="盘点总数量" v-if="getIsView()">
                                <el-input disabled placeholder="请输入盘点总数量" v-model="form.totalNumber"></el-input>
                            </el-form-item>
                            <span class="viewText" v-else>盘点总数量:{{ form.totalNumber }} </span>
                        </el-col>
                        <el-col :span="3" :class="!getIsView()?'viewCol':''">
                            <el-form-item prop="totalAmount" label="盘点总金额" v-if="getIsView()">
                                <el-input disabled placeholder="请输入盘点总金额" v-model="form.totalAmount"></el-input>
                            </el-form-item>
                            <span class="viewText" v-else>盘点总金额:{{ form.totalAmount }} </span>
                        </el-col>


                        <el-col :span="3" :class="!getIsView()?'viewCol':''">
                            <el-form-item prop="totalInventorySurplusQuantity" label="盘盈总数量" v-if="getIsView()">
                                <el-input disabled placeholder="请输入盘盈总数量"
                                    v-model="form.totalInventorySurplusQuantity"></el-input>
                            </el-form-item>
                            <span class="viewText" v-else>盘盈总数量:{{ form.totalInventorySurplusQuantity }} </span>
                        </el-col>
                        <el-col :span="3" :class="!getIsView()?'viewCol':''">
                            <el-form-item prop="totalInventorySurplusAmount" label="盘盈总金额" v-if="getIsView()">
                                <el-input disabled placeholder="请输入盘盈总金额"
                                    v-model="form.totalInventorySurplusAmount"></el-input>
                            </el-form-item>
                            <span class="viewText" v-else>盘盈总金额:{{ form.totalInventorySurplusAmount }} </span>
                        </el-col>
                        <el-col :span="3" :class="!getIsView()?'viewCol':''">
                            <el-form-item prop="totalInventoryLossQuantity" label="盘亏总数量" v-if="getIsView()">
                                <el-input disabled placeholder="请输入盘亏总数量"
                                    v-model="form.totalInventoryLossQuantity"></el-input>
                            </el-form-item>
                            <span class="viewText" v-else>盘亏总数量:{{ form.totalInventoryLossQuantity }} </span>
                        </el-col>
                        <el-col :span="3" :class="!getIsView()?'viewCol':''">
                            <el-form-item prop="totalInventoryLossAmount" label="盘亏总金额" v-if="getIsView()">
                                <el-input disabled placeholder="请输入盘亏总金额"
                                    v-model="form.totalInventoryLossAmount"></el-input>
                            </el-form-item>
                            <span class="viewText" v-else>盘亏总金额:{{ form.totalInventoryLossAmount }} </span>
                        </el-col>
                        <el-col :span="4" :class="!getIsView()?'viewCol':''">
                            <el-form-item label="盘点维度" prop="dimension" v-if="getIsView()">
                                <el-radio-group :disabled="!editMode || loading" v-model="form.dimension">
                                    <el-radio :label="0">按库存</el-radio>
                                    <el-radio :label="1">按批次</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <span class="viewText" v-else>盘点维度:{{ form.dimension == 0 ? '按库存' : '按批次' }} </span>
                        </el-col>
                        <el-col :span="6" :class="!getIsView()?'viewCol':''">
                            <el-form-item label="备注" prop="remark" v-if="getIsView()">
                                <el-input :disabled="!editMode" placeholder="备注" v-model="form.remark"></el-input>
                            </el-form-item>
                            <span class="viewText" v-else>备注:{{ form.remark }} </span>
                        </el-col>
                    </el-row>
                    <el-row style="margin-top: 20px"></el-row>
                </div>

                <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
                    <div style="width: 88%; display: flex">
                        <div class="start-label" />
                        <span class="text">盘点明细</span>
                    </div>

                    <div v-if="editMode" style="margin: 20px 0 12px 10px">
                        <el-button class="btn default" size="small" v-preventReClick
                            @click="handleAddChildForm">新增明细</el-button>
                        <el-button class="btn" size="small" :disabled="childMultiple" v-preventReClick type="danger"
                            @click="handleDeleteChildForm">删除</el-button>
                        <el-button class="btn default" size="small" v-preventReClick v-if="form.dimension == 0"
                            @click="openScanner">点击开始扫描</el-button>
                        <el-input v-if="form.dimension == 0" :disabled="!editMode" placeholder="扫描标签码" v-model="tagCode"
                            ref="tagCodeInput" style="width:300px;margin-left:30px" @change="tagCodeChange"></el-input>
                        <el-button style="float: right" class="btn default" size="small" v-preventReClick
                            @click="fillNumber">一键填充盘点数量</el-button>
                    </div>
                    <div v-else style="margin: 20px 0 12px 10px">
                        <el-button class="btn default" :disabled="$route.query.formMode != 3" size="small"
                            v-preventReClick @click="handleAddChildForm">新增明细</el-button>
                        <el-input v-if="form.dimension == 0" :disabled="$route.query.formMode != 3" placeholder="扫描标签码"
                            v-model="tagCode" ref="tagCodeInput" style="width:300px;margin-left:30px"
                            @change="tagCodeChange"></el-input>
                        <el-button :disabled="$route.query.formMode != 3" style="float: right" class="btn default"
                            size="small" v-preventReClick @click="fillNumber">一键填充盘点数量</el-button>
                    </div>

                    <el-table ref="childTable" border :data="form.details" max-height="600"
                        style="width: auto; margin: 0 10px" @cell-dblclick="cellDblclick"
                        @selection-change="handleChildSelectionChange" stripe
                        :header-cell-style="{ background: '#DDEBFF' }" v-loading="loading"
                        element-loading-text="系统正拼命加载中" element-loading-spinner="el-icon-loading">
                        <el-table-column type="index" width="50" fixed> </el-table-column>
                        <el-table-column type="selection" width="55" align="center" fixed></el-table-column>
                        <el-table-column show-overflow-tooltip prop="productName" label="产品" fixed width="130" />
                        <el-table-column show-overflow-tooltip prop="specName" label="产品规格" fixed width="110" />
                        <el-table-column prop="supplierProductNo" label="供应商产品编码" width="180"></el-table-column>

                        <el-table-column prop="minUnit" label="最小单位" width="80" />
                        <el-table-column prop="price" label="单价" width="100" />
                        <el-table-column prop="batch" label="批次号" width="100" />
                        <el-table-column v-if="form.dimension == 0" :key="'serialNo'" prop="serialNo" label="序列号"
                            width="100" />
                        <el-table-column prop="inventoryNumber" label="盘点数量" width="120" >
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.inventoryNumber" :disabled="!editMode&&!showWorkFlowInfo" placeholder="请输入盘点数量" @change="changeNumber(scope.row)"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="stockNumber" label="库存数量" width="80" />
                        <el-table-column prop="diffNumber" label="盈亏数量" width="80" />
                        <el-table-column prop="result" label="盘点结果" width="80" />
                        <el-table-column prop="amount" label="盘点金额" width="100" />
                        <el-table-column show-overflow-tooltip prop="remark" label="备注" width="200" />
                        <el-table-column show-overflow-tooltip prop="manufacturerName" label="生产厂家" width="100" />
                        <el-table-column prop="packSpec" label="包装规格" width="100" />
                        <el-table-column v-if="form.dimension == 0" :key="'mainNo'" show-overflow-tooltip prop="mainNo"
                            label="主条码" width="120" />
                        <el-table-column v-if="form.dimension == 0" :key="'traceNo'" show-overflow-tooltip
                            prop="traceNo" label="追溯码" width="120" />
                        <el-table-column prop="validityDate" label="有效期" width="150">
                            <template slot-scope="scope">
                                {{ scope.row.validityDate ? parseTime(new Date(scope.row.validityDate), "{y}-{m}-{d}") :
                                    "" }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="longTime" label="长期" width="60">
                            <template slot-scope="scope">
                                {{ scope.row.longTime == 1 ? "是" : "否" }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="manufactureDate" label="生产日期" width="150">
                            <template slot-scope="scope">
                                {{ scope.row.manufactureDate ? parseTime(new Date(scope.row.manufactureDate),
                                    "{y}-{m}-{d}") : "" }}
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="onlineNo" label="挂网号"
                            width="100"></el-table-column>
                        <el-table-column prop="locationName" label="货位" width="80" />
                        <el-table-column show-overflow-tooltip prop="medicalInsuranceCategoryNo" label="医保代码"
                            width="150"></el-table-column>
                        <el-table-column fixed="right" prop="operation" :label="form.dimension == 0 ? '标签详情' : '个体详情'"
                            width="100">
                            <template slot-scope="scope">
                                <el-button type="text" v-if="scope.row.hasTagCode == 1 && form.dimension == 0"
                                    v-preventReClick class="color-blue" @click="tagCodeView(scope.row)">查看</el-button>
                                <el-button type="text" v-if="scope.row.isIndividual == 1 && form.dimension == 1"
                                    v-preventReClick class="color-blue"
                                    @click="dimensionChange(scope.row)">查看</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
            </el-form>
            <el-dialog title="产品信息" :visible.sync="openSubformModal" :center="true" width="1100px"
                :before-close="cancelChildDialog" :close-on-click-modal="false">
                <el-form label-position="top" label-width="80px" ref="childForm" :model="childForm"
                    :rules="childFormRules">
                    <el-row v-if="isScan">
                        <el-col :span="24">
                            <el-form-item label="扫码框">
                                <el-input placeholder="请扫码" ref="no" @change="mainNoChange" v-model="childForm.no"
                                    @focus="scanInputFocus" @blur="scanInputBlur"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item prop="mainNo" label="主条码">
                                <el-input :disabled="!Boolean(form.status)" placeholder="请输入主条码"
                                    v-model="childForm.mainNo"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item prop="traceNo" label="追溯码">
                                <el-input :disabled="!Boolean(form.status)" placeholder="请输入追溯码"
                                    v-model="childForm.traceNo"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item prop="supplierProductNo" label="供应商产品编码">
                                <el-input disabled v-model="childForm.supplierProductNo"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item prop="productName" label="产品名称">
                                <el-input v-if="isScan" disabled v-model="childForm.productName"></el-input>

                                <SelectTable v-if="!isScan" :disabled="!isAdd && !editMode"
                                    :columns="!editMode ? supplierProductColumns : stockColumns"
                                    :innerName="childForm.productName"
                                    :dataList="!editMode ? STATIC_SupplierProducts : STATIC_Stocks"
                                    @filterMethod="getProductList" @change="productChange" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item prop="specName" label="规格型号">
                                <el-input disabled v-model="childForm.specName"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item prop="productRegistCertId" label="产品注册证">
                                <el-input disabled v-model="childForm.productRegistCertName"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item prop="productRegistCertNo" label="注册证号">
                                <el-input disabled v-model="childForm.productRegistCertNo"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item prop="supplierName" label="供应商">
                                <el-input disabled v-model="childForm.supplierName"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item prop="manufacturerName" label="生产厂家">
                                <el-input disabled v-model="childForm.manufacturerName"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item prop="onlineNo" label="挂网号">
                                <el-input disabled v-model="childForm.onlineNo"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item prop="brand" label="品牌">
                                <el-input disabled v-model="childForm.brand"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item prop="packSpec" label="包装规格">
                                <el-input :disabled="!editMode" v-model="childForm.packSpec"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item prop="minUnit" label="最小单位">
                                <el-input disabled v-model="childForm.minUnit"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item prop="unit" label="包装单位">
                                <el-input disabled v-model="childForm.unit"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item prop="manufactureDate" label="生产日期">
                                <el-date-picker :disabled="!approveDisabled" v-model="childForm.manufactureDate"
                                    size="small" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                    placeholder="选择生产日期" style="width:100%"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item prop="validityDate" label="有效期">
                                <el-date-picker :disabled="!approveDisabled || Boolean(childForm.longTime)"
                                    v-model="childForm.validityDate" size="small" type="date" format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd" placeholder="选择有效期" style="width:100%"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="2">
                            <el-form-item prop="longTime" label="长期">
                                <el-switch v-model="childForm.longTime" :disabled="!approveDisabled"
                                    @change="longTimeChange(childForm)" active-color="#286AB4" inactive-color="#D4D4D4"
                                    :active-value="1" :inactive-value="0"></el-switch>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item prop="batch" label="批次号">
                                <el-input :disabled="!approveDisabled" placeholder="请输入批次号"
                                    v-model="childForm.batch"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item prop="serialNo" label="序列号">
                                <el-input :disabled="!approveDisabled" placeholder="请输入序列号"
                                    v-model="childForm.serialNo"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item prop="locationName" label="货位">
                                <!-- <el-input disabled v-model="childForm.locationName"></el-input> -->
                                <el-select :disabled="!approveDisabled" placeholder="请选择货位"
                                    v-model="childForm.locationName" filterable @change="childLocationChange"
                                    style="width:100%">
                                    <el-option v-for="item in STATIC_Locations" :key="item.id" :label="item.name"
                                        :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item prop="stockNumber" label="库存数量">
                                <el-input-number disabled v-model="childForm.stockNumber" :min="0" :precision="2"
                                    :controls="false" style="width: 100%"></el-input-number>
                                <!-- <el-input :disabled="!editMode" placeholder="请输入数量" type="number" min="0" ref="number" v-model="childForm.number" @input="autoAmount"></el-input> -->
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item prop="inventoryNumber" label="盘点数量">
                                <el-input-number :disabled="!approveDisabled" placeholder="请输入实点数量" :precision="2"
                                    ref="number" :controls="false" v-model="childForm.inventoryNumber"
                                    @input="childNumberChange"></el-input-number>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item prop="diffNumber" label="盈亏数量">
                                <el-input disabled type="number" v-model="childForm.diffNumber"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item prop="price" label="单价">
                                <el-input disabled @input="autoAmount" v-model="childForm.price"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item prop="amount" label="金额">
                                <el-input disabled v-model="childForm.amount"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item prop="medicalInsuranceCategoryNo" label="医保代码">
                                <el-input disabled v-model="childForm.medicalInsuranceCategoryNo"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item prop="remark" label="备注">
                                <el-input :disabled="!approveDisabled" v-model="childForm.remark"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <div slot="footer" class="dialog-footer" style="">
                    <el-button v-if="!isScan && editMode" class="btn primary" type="primary" size="small"
                        v-preventReClick @click="continueAdd">新增下一条</el-button>
                    <el-button class="btn" size="small" v-preventReClick @click="cancelChildDialog">取 消</el-button>
                    <el-button class="btn primary" type="primary" size="small" v-preventReClick
                        @click="submitChildForm">确
                        定</el-button>
                </div>
            </el-dialog>
        </div>
        <div slot="footer" class="footer-bottom">
            <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
            <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确
                定</my-button>
            <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确
                定</my-button>
            <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
        </div>
        <LabelDetailsDialog v-if="labelDetailsVisible" :open="labelDetailsVisible" :data="labelDetailsData"
            :labelScanTagCodeIds="labelScanTagCodeIds" @close="closeLabelDetailsDialog" />
        <IndividualDialog v-if="individualVisible" :open="individualVisible" :data="individualData"
            @close="closeIndividualDialog" @add="addDetails" @del="delDetails" @confirm="confirmIndividualDialog" />
    </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import OutStockScan from '@/mixin/outStockScan-mixin'
import {
    GetStocks,
    SpdRejectInventory,
    SpdGetInventoryById,
    SpdSaveInventory,
    GetApplyOutStocks,
    ValidateUnfinishedDeptInStock,
    GetTagCodeList,
    GetStockInfoByTagCode,
    GetInvertoryStock
} from "@/api";
// import { StockCategoryOptions } from "@/enum";
import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";
import LabelDetailsDialog from "@/components/labelDetails-dialog";
import IndividualDialog from "@/components/individual-dialog";
import { Debounce } from '@/utils/utils'

export default {
    name: "manufacturerEdit",
    mixins: [GetDataMixin, GetDataSpdMixin, OutStockScan],
    components: {
        SelectTable,
        ApproveInfo,
        LabelDetailsDialog,
        IndividualDialog,
    },
    data() {
        return {
            GetDataAction: SpdGetInventoryById,
            SaveDataAction: SpdSaveInventory,
            reject: SpdRejectInventory,
            form: {},
            // StockCategoryOptions: StockCategoryOptions,
            rules: {
                warehouseName: [{
                    required: true,
                    message: '请选择盘点仓库',
                    trigger: 'blur'
                }],
                billingLogo: [{
                    required: true,
                    message: '请选择计费标识',
                    trigger: 'blur'
                }],
                date: [{
                    required: true,
                    message: '请选择盘点日期',
                    trigger: 'blur'
                }],
                stockCategory: [{
                    required: true,
                    message: '请选择盘点类型',
                    trigger: 'blur'
                }],
                dimension: [{
                    required: true,
                    message: '请选择盘点维度',
                    trigger: 'blur'
                }],
                // supplierName: [{ required: true, message: '请选择供应商', trigger: 'blur' }]
            },
            childFormRules: {
                productName: [{
                    required: true,
                    message: "请选择产品",
                    trigger: "blur"
                }],
                // manufactureDate: [
                //   { required: true, message: "请选择生产日期", trigger: "blur" },
                //   { validator: this.validateManufacturerDate, trigger: 'blur' },
                //   { validator: this.validateDateRange, trigger: 'blur' }
                // ],
                validityDate: [
                    // { required: true, message: "请选择有效期", trigger: "blur" },
                    {
                        validator: this.validateValidityDate,
                        trigger: 'blur'
                    },
                    {
                        validator: this.validateDateRange,
                        trigger: 'blur'
                    }
                ],
                // manufactureDate: [{ required: true, message: "请选择生产日期", trigger: "blur" }],
                // validityDate: [{ required: true, message: "请选择有效期", trigger: "blur" }],
                // batch: [{ required: true, message: "请输入批次号", trigger: "blur" }],
                // productRegistCertId: [{ required: true, message: "请选择产品注册证", trigger: "blur" }],
                // packSpec: [{ required: true, message: "请输入包装规格", trigger: "blur" }],
                // price: [
                //   { required: true, message: "请输入计费价", trigger: "blur" },
                // ],
                inventoryNumber: [{
                    required: true,
                    message: "数量不能为空",
                    trigger: "blur"
                },

                ]
            },
            editMode: false,
            showWorkFlowInfo: false,
            // 子表
            childIds: [],
            childMultipleSelection: [],
            childMultiple: true,
            childForm: {},

            isScan: false,
            loading: false,
            approveDisabled: false,
            // patientList: [],
            isAdd: false,
            tagCode: '',
            labelScanTagCodeIds: [],
            individualVisible: false,
            individualData: {},
            dimensionDetails: [],
            dimensionData: {},
            details: []
        };
    },
    watch: {
        'form.dimension': {
            handler(newVal, oldVal) {
                if (newVal == 1) {
                    this.$set(this.form, 'details', this.dimensionDetails)
                    // this.getDimensionDetails()
                    // this.form.details =  this.dimensionDetails 
                } else {
                    this.$set(this.form, 'details', this.details)
                    // this.form.details = this.details
                }
            },
            deep: true
        }
    },
    created() {
        var query = this.$route.query;
        if (query.id) {
            this.handleUpdate(query.id);
        } else {
            this.handleAdd();
        }

        this.getWarehousesBySessionWarehouseId('')
    },
    methods: {
        getDimensionDetails() {
            this.dimensionDetails = []
            let arr = JSON.parse(JSON.stringify(this.details))
            // 创建合并对象用于分组累加
            const mergedMap = {};
            // 遍历数组进行合并操作
            arr.forEach(item => {
                // 使用productId和batch创建唯一键
                const key = `${item.supplierProductNo}-${item.batch}-${item.price}`;
                if (mergedMap[key]) {
                    mergedMap[key].inventoryNumber = (mergedMap[key].inventoryNumber || 0) + (item.inventoryNumber || 0);
                    mergedMap[key].stockNumber = (mergedMap[key].stockNumber || 0) + (item.stockNumber || 0);
                    mergedMap[key].diffNumber = mergedMap[key].inventoryNumber - mergedMap[key].stockNumber
                    mergedMap[key].result = mergedMap[key].diffNumber > 0 ? '盘盈' : mergedMap[key].diffNumber === 0 ? '正常' : '盘亏';
                    mergedMap[key].amount = (mergedMap[key].inventoryNumber * mergedMap[key].price).toFixed(4) * 1;
                    mergedMap[key].isIndividual = item.serialNo ? 1 : (mergedMap[key].isIndividual !== undefined ? mergedMap[key].isIndividual : 0);
                } else {
                    // 新组合，深拷贝对象存入Map
                    mergedMap[key] = JSON.parse(JSON.stringify(item));
                    mergedMap[key].isIndividual = item.serialNo ? 1 : 0;
                }
            });
            // 将合并结果转换为数组并赋值
            this.dimensionDetails = Object.values(mergedMap);
            this.form.details = this.dimensionDetails
        },
        // 新建
        handleAdd() {
            this.resetForm();
            this.editMode = true;
            this.approveDisabled = true
        },
        // 编辑
        handleUpdate(id) {
            this.GetDataAction({
                id
            }).then((res) => {
                // this.resetForm()
                this.form = res.returnData;
                this.form.details.forEach((e, index) => {
                    e.$index = index + 1;
                });

                this.details = JSON.parse(JSON.stringify(this.form.details)).map(v => {
                    v.actualQuantity = v.inventoryNumber
                    return v
                })
                // 创建合并对象用于分组累加
                const mergedMap = {};
                // 遍历数组进行合并操作
                this.details.forEach(item => {
                    // 使用productId和batch创建唯一键
                    const key = `${item.supplierProductNo}-${item.batch}-${item.price}`;
                    if (mergedMap[key]) {
                        // 已存在相同组合，累加数值字段
                        mergedMap[key].stockNumber = (mergedMap[key].stockNumber || 0) + (item.stockNumber || 0);
                        mergedMap[key].inventoryNumber = (mergedMap[key].inventoryNumber || 0) + (item.inventoryNumber || 0);
                        mergedMap[key].diffNumber = (mergedMap[key].diffNumber || 0) + (item.diffNumber || 0);
                        mergedMap[key].result = mergedMap[key].diffNumber > 0 ? '盘盈' : mergedMap[key].diffNumber == 0 ? '正常' : '盘亏';
                        mergedMap[key].isIndividual = item.serialNo ? 1 : (mergedMap[key].isIndividual !== undefined ? mergedMap[key].isIndividual : 0);
                        mergedMap[key].amount = (mergedMap[key].inventoryNumber * mergedMap[key].price).toFixed(4) * 1;
                    } else {
                        // 新组合，深拷贝对象存入Map
                        mergedMap[key] = JSON.parse(JSON.stringify(item));
                        mergedMap[key].isIndividual = item.serialNo ? 1 : 0;
                         mergedMap[key].amount = (mergedMap[key].inventoryNumber * mergedMap[key].price).toFixed(4) * 1;
                    }
                });
                // 将合并结果转换为数组并赋值
                this.dimensionDetails = Object.values(mergedMap);
                if (this.form.dimension == 1) {
                    this.form.details = this.dimensionDetails
                } else {
                    this.form.details = this.details
                }

                this.initWorkFlowProperty(this.form);

                if (this.form.status == 0 || (this.formMode == 3 && this.form.status == 1 && this.form.approverIds && this.form.approverIds.split(';').indexOf(this.userInfo.id + '') != -1)) {
                    this.approveDisabled = true
                }
            });
        },
        // 保存
        submit() {
            this.$store.dispatch('SetLoading', true)
            this.$refs["form"].validate((valid) => {
                if (!valid) {
                    this.$store.dispatch('SetLoading', false)
                    return false;
                }
                var valdateResult = this.productDetailRepeatValidate(this.form.details)

                if (!valdateResult.flag) {
                    this.$my_message(valdateResult.msg, 'warning')
                    this.$store.dispatch('SetLoading', false)
                    return
                }

                // // 新增：检查所有明细行盘点数量是否都为0
                // const allZero = this.form.details.every(item => {
                //     // 兼容数字和字符串类型，转换为数值后判断
                //     const num = Number(item.inventoryNumber);
                //     return !isNaN(num) && num === 0;
                // });
                // if (allZero) {
                //     this.$my_message('所有行的盘点数量都为0，请仔细核对', 'warning');
                //     this.$store.dispatch('SetLoading', false);
                //     return;
                // }

                let fn = () => {
                    this.form.details = this.details
                    this.SaveDataAction(this.form).then((res) => {
                        this.$my_message(`执行成功`, "success");
                        sessionStorage.setItem("editMode", 0);
                        // this.$router.push({ path: this.getMainPath(this.$route.path) });
                        this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
                    }).finally(() => {
                        this.$store.dispatch('SetLoading', false)
                    });;
                }
                if (this.$route.query.formMode == 1 && this.$route.query.formMode == 3 && this.form.stockCategory == 0) {
                    ValidateUnfinishedDeptInStock(this.form).then((res) => {
                        if (res.returnData) {
                            this.$my_message(res.returnData, 'warning')
                            this.$store.dispatch('SetLoading', false)
                            return
                        }
                        fn()
                    })
                } else {
                    fn()
                }
            });
        },
        resetForm() {
            this.form = {
                supplierId: "",
                deliveryTime: new Date(),
                "warehouseCategory": "",
                "warehouseId": '',
                warehouseName: '',
                warehouseManagerId: '',
                warehouseManagerName: '',
                // "warehouseId": this.userInfo.defaultWarehouseId,
                // warehouseName: this.userInfo.defaultWarehouseName,
                // warehouseManagerId: this.userInfo.defaultWarehouseManagerId,
                // warehouseManagerName: this.userInfo.defaultWarehouseManagerName,
                totalNumber: 0,
                totalAmount: 0,
                totalInventorySurplusQuantity: 0,
                totalInventorySurplusAmount: 0,
                totalInventoryLossQuantity: 0,
                totalInventoryLossAmount: 0,
                orderNo: "",
                stockCategory: 0,
                remark: "",
                "balanceStatus": 2,
                details: [],
                createdTime: this.parseTime(new Date()),
                updateTime: this.parseTime(new Date()),
                createdUserName: this.userInfo.name,
                ownerDeptName: this.userInfo.deptName,
                date: this.parseTime(new Date(), "{y}-{m}-{d}"),
                orgCode: sessionStorage.getItem('orgId'),
                billingLogo: 3,
                dimension: 0
            };
        },
        // 取消编辑
        cancel() {
            // this.$router.push({ path: this.getMainPath(this.$route.path) });
            this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
        },

        // 明细表
        handleAddChildForm() {
            this.isAdd = true
            this.openSubformModal = true;
            this.editChildren = false;
            this.resetDetailFormData();
            this.getProductList('')
            this.isScan = false;
        },
        handleDeleteChildForm() {
            this.form.details = this.form.details.filter(
                (i) => !this.childIds.includes(i.$index)
            );
            this.form.details.forEach((e, index) => {
                e.$index = index + 1;
            });
            if (this.form.dimension == 1) {
                const formDetailsKeys = new Set();
                this.form.details.forEach(item => {
                    const key = `${item.supplierProductNo}_${item.batch}_${item.price}`;
                    formDetailsKeys.add(key);
                });
                this.details = JSON.parse(JSON.stringify(this.details.filter(item => {
                    const key = `${item.supplierProductNo}_${item.batch}_${item.price}`;
                    return formDetailsKeys.has(key);
                })));
                this.getDimensionDetails()
            } else {
                this.details = JSON.parse(JSON.stringify(this.form.details))
            }

            this.autoTotalAmount();
        },
        handleChildSelectionChange(selection) {
            this.childMultipleSelection = selection;
            this.childIds = selection.map((item) => item.$index);
            this.childMultiple = !selection.length;
        },
        cellDblclick(row, column, cell, event) {
            // 打开子表弹窗
            this.openSubformModal = true;
            this.editChildren = true;
            this.resetDetailFormData();
            this.childForm = JSON.parse(JSON.stringify(row));
            this.isScan = false;
            // this.$set(
            //   this.childForm,
            //   "patientIdArr",
            //   this.childForm.patientInfos.map((e) => e.id)
            // );

            var that = this
            setTimeout(function () {
                that.$refs.number.focus()
                that.$refs.number.select()
            }, 1)
            // this.getProductRegistCertDetails(this.childForm.productId);
        },

        resetDetailFormData() {
            this.childForm = {
                $index: this.form.details.length + 1,
                no: '',
                "productName": "",
                "specName": "",
                "manufacturerName": "",
                "locationName": "",
                "mainNo": "",
                "traceNo": "",
                supplierProductId: '',
                "productId": '',
                "specId": '',
                productRegistCertId: '',
                "productRegistCertNo": "",
                "onlineNo": "",
                "unit": "",
                "minUnit": "",
                "packSpec": "",
                "manufacturerId": '',
                "locationId": '',
                "manufactureDate": "",
                "batch": "",
                "validityDate": "",
                "serialNo": "",
                "stockNumber": 0,
                "inventoryNumber": 0,
                "diffNumber": 0,
                "price": 0,
                "amount": 0,
                "remark": "",
                patientIdArr: [],
                patientInfos: [],
            };
        },
        cancelChildDialog() {
            this.openSubformModal = false;
            this.isAdd = false
        },
        submitChildForm() {
            this.pushChildForm(true);
        },
        continueAdd() {
            this.editChildren = false;
            this.pushChildForm();
            // this.resetDetailFormData();

            this.getProductList('')
        },
        pushChildForm(close) {
            let result = true
            
            this.$refs["childForm"].validate((valid) => {
                result = valid
                if (!valid) {
                    return false;
                }
                this.childForm.orgCode = sessionStorage.getItem('orgId')        
                if (this.childForm.mainNo && this.childForm.traceNo) {
                    var childForm = this.childForm
                    // 添加行
                    let arr = this.form.details.filter(
                        (item) => item.mainNo == childForm.mainNo && item.traceNo == childForm.traceNo
                    );
                    // 添加行记录
                    if (arr.length > 0) {
                        // 存在则把列表的数据拿过来，并且数量加1
                        this.form.details = this.form.details.map((item) => {
                            if (
                                item.mainNo == childForm.mainNo &&
                                item.traceNo == childForm.traceNo
                            ) {
                                item.packSpec = childForm.packSpec;
                                item.locationId = childForm.locationId;
                                item.locationName = childForm.locationName;
                                item.manufactureDate = childForm.manufactureDate;
                                item.batch = childForm.batch;
                                item.validityDate = childForm.validityDate;
                                item.serialNo = childForm.serialNo;
                                item.remark = childForm.remark;
                                item.number = childForm.number;
                                item.inventoryNumber = childForm.inventoryNumber
                                item.diffNumber = childForm.diffNumber
                                // item.unUseNumber = childForm.unUseNumber
                                item.price = childForm.price;
                                item.amount = childForm.amount;
                                item.result = childForm.diffNumber > 0 ? '盘盈' : childForm.diffNumber == 0 ? '正常' : '盘亏';
                                if (this.form.dimension == 1) {
                                    let data = JSON.parse(JSON.stringify(childForm))
                                    data.serialNo = ''
                                    this.autoDetails(data)
                                }
                            }
                            return item;
                        });
                        this.details.forEach(i => {
                            if (i.mainNo == childForm.mainNo && i.traceNo == childForm.traceNo) {
                                i.packSpec = childForm.packSpec;
                                i.locationId = childForm.locationId;
                                i.locationName = childForm.locationName;
                                i.manufactureDate = childForm.manufactureDate;
                                i.batch = childForm.batch;
                                i.validityDate = childForm.validityDate;
                                i.serialNo = childForm.serialNo;
                                i.remark = childForm.remark;
                                i.number = childForm.number;
                                i.inventoryNumber = childForm.inventoryNumber
                                i.diffNumber = childForm.diffNumber
                                // item.unUseNumber = childForm.unUseNumber
                                i.price = childForm.price;
                                i.amount = childForm.amount;
                                i.result = childForm.diffNumber > 0 ? '盘盈' : childForm.diffNumber == 0 ? '正常' : '盘亏';
                            }
                        })

                    } else {
                        // 不存在则添加行记录
                        var childForm = JSON.parse(JSON.stringify(this.childForm))
                        childForm.$index = this.form.details.length + 1
                        this.form.details.push(childForm)
                        this.details = JSON.parse(JSON.stringify(this.form.details))
                    }
                } else {
                    if (this.editChildren) {
                        let item = this.form.details.find(
                            (e) => e.$index == this.childForm.$index
                        );
                        Object.assign(item, this.childForm);
                        if (this.form.dimension != 1) {
                            let i = this.details.find(e => e.$index == this.childForm.$index)
                            Object.assign(i, this.childForm);
                        }
                        if (this.form.dimension == 1) {
                            let data = JSON.parse(JSON.stringify(this.childForm))
                            data.serialNo = ''
                            this.autoDetails(data)    
                        }
                    } else {
                        let data = JSON.parse(JSON.stringify(this.childForm))
                        this.details.push(data)
                        if (this.form.dimension == 1) {
                            this.$nextTick(() => {
                                const key = `${data.supplierProductNo}-${data.batch}-${data.price}`;
                                let isSame = false
                                this.form.details.forEach(item => {
                                    let ItemKey = `${item.supplierProductNo}-${item.batch}-${item.price}`;
                                    if (key == ItemKey) {
                                        item.inventoryNumber = item.inventoryNumber + data.inventoryNumber
                                        item.diffNumber = item.inventoryNumber - item.stockNumber
                                        item.result = item.diffNumber > 0 ? '盘盈' : item.diffNumber == 0 ? '正常' : '盘亏';
                                        item.amount = (item.inventoryNumber * item.price).toFixed(4) * 1;
                                        isSame = true
                                    }
                                })
                                if (!isSame) {
                                    if(data.serialNo){
                                        data.isIndividual=1
                                    }
                                    
                                    this.form.details.push(data)
                                }
                            })
                        }

                    }
                }
                this.autoTotalAmount();
                this.resetDetailFormData();
                if (close) {
                    this.openSubformModal = false;
                    this.isAdd = false
                    this.count = 0;
                    this.isScan = false;
                }
            });
            return result
        },
        autoDetails(obj) {
            let data = JSON.parse(JSON.stringify(obj))
            let ObjKey = `${data.supplierProductNo}-${data.batch}-${data.price}-${data.serialNo?data.serialNo:''}`;
            let num = 0
            this.details.forEach(item => {
                let ItemKey = `${item.supplierProductNo}-${item.batch}-${item.price}-${data.serialNo?item.serialNo:''}`;
                if (ObjKey == ItemKey) {
                    if (obj.actualQuantity) {
                        item.actualQuantity = obj.actualQuantity
                    }
                    if (item.stockNumber < data.inventoryNumber && item.stockNumber != 0) {
                        item.inventoryNumber = item.stockNumber
                        data.inventoryNumber = data.inventoryNumber - item.stockNumber;
                        item.diffNumber = 0
                        item.result = '正常'
                        item.amount = (item.inventoryNumber * item.price).toFixed(4) * 1;
                    } else if (item.stockNumber > data.inventoryNumber && item.stockNumber != 0) {
                        item.inventoryNumber = data.inventoryNumber
                        item.diffNumber = item.inventoryNumber - item.stockNumber
                        item.result = item.diffNumber > 0 ? '盘盈' : item.diffNumber == 0 ? '正常' : '盘亏';
                        item.amount = (item.inventoryNumber * item.price).toFixed(4) * 1;
                        data.inventoryNumber = 0
                    } else if (item.stockNumber == data.inventoryNumber && item.stockNumber != 0) {
                        item.inventoryNumber = data.inventoryNumber
                        item.diffNumber = 0
                        item.result = '正常'
                        item.amount = (item.inventoryNumber * item.price).toFixed(4) * 1;
                        data.inventoryNumber = 0
                    } else if (item.stockNumber == 0) {
                        item.inventoryNumber = data.inventoryNumber
                        item.diffNumber = item.inventoryNumber - item.stockNumber
                        data.inventoryNumber - item.inventoryNumber
                        item.amount = (item.inventoryNumber * item.price).toFixed(4) * 1;
                        item.result = '盘盈'
                    }
                    num += Number(item.inventoryNumber)
                }
            });

            for (let i = 0; i < this.details.length; i++) {
                const item = this.details[i];
                const ItemKey = `${item.supplierProductNo}-${item.batch}-${item.price}-${data.serialNo?item.serialNo:''}`;
                if (num < obj.inventoryNumber && ObjKey == ItemKey && num != 0) {
                    item.inventoryNumber = (Number(obj.inventoryNumber) - num) + Number(item.inventoryNumber);
                    item.diffNumber = item.inventoryNumber - item.stockNumber;
                    item.amount = (item.inventoryNumber * item.price).toFixed(4) * 1;
                    item.result = item.diffNumber > 0 ? '盘盈' : item.diffNumber === 0 ? '正常' : '盘亏';
                    break; // 现在break可以正确退出循环
                }
            }

            this.autoTotalAmount();
        },
        childNumberChange() {
            this.childForm.diffNumber = (this.childForm.inventoryNumber - this.childForm.stockNumber).toFixed(4) * 1
            this.childForm.result = this.childForm.diffNumber < 0 ? '盘亏' : this.childForm.diffNumber > 0 ? '盘盈' : '正常'

            this.autoAmount();
        },
        autoAmount() {
            this.childForm.amount = (this.childForm.inventoryNumber * this.childForm.price).toFixed(4) * 1;
        },
        autoTotalAmount() {
            let totalNumber = 0;
            let totalAmount = 0;
            let totalStockNumber = 0;
            let totalStockAmount = 0;
            let totalInventorySurplusQuantity = 0;
            let totalInventorySurplusAmount = 0;
            let totalInventoryLossQuantity = 0;
            let totalInventoryLossAmount = 0;
            this.details.forEach((element, index) => {
                // 重置表格数据的序号
                element.$index = index + 1;
                totalNumber = totalNumber * 1 + element.inventoryNumber * 1;
                totalAmount = totalAmount * 1 + element.amount * 1;
                totalStockNumber = totalStockNumber * 1 + element.stockNumber * 1;
                totalStockAmount = totalStockAmount * 1 + element.stockNumber * 1 * element.price;
                if (element.diffNumber > 0) {
                    totalInventorySurplusQuantity = totalInventorySurplusQuantity * 1 + element.diffNumber * 1;
                    totalInventorySurplusAmount = totalInventorySurplusAmount * 1 + element.diffNumber * 1 * element.price;;
                } else if (element.diffNumber < 0) {
                    totalInventoryLossQuantity = totalInventoryLossQuantity * 1 + ~~Math.abs(element.diffNumber)
                    totalInventoryLossAmount = totalInventoryLossAmount * 1 + ~~Math.abs(element.diffNumber) * element.price;
                }
            });
            this.form.totalNumber = totalNumber.toFixed(3) * 1;
            this.form.totalAmount = totalAmount.toFixed(4) * 1;
            this.form.totalStockNumber = totalStockNumber.toFixed(3) * 1;
            this.form.totalStockAmount = totalStockAmount.toFixed(4) * 1;
            this.form.totalInventorySurplusQuantity = totalInventorySurplusQuantity.toFixed(4) * 1;
            this.form.totalInventorySurplusAmount = totalInventorySurplusAmount.toFixed(4) * 1;
            this.form.totalInventoryLossQuantity = totalInventoryLossQuantity.toFixed(4) * 1;
            this.form.totalInventoryLossAmount = totalInventoryLossAmount.toFixed(4) * 1;
        },

        // scan

        openScanner(ev) {
            this.count = 0;
            this.resetDetailFormData();
            this.isScan = true;
            this.openSubformModal = true;

            ev.target.blur();
        },

        // change event
        childLocationChange(val) {
            this.childForm.locationId = val
        },
        patientChange() {
            this.childForm.patientInfos = this.patientList.filter(e => this.childForm.patientIdArr.indexOf(e.id) != -1)
            console.log(this.childForm.patientInfos, 'infos')
            this.childForm.patientIds = this.childForm.patientIdArr.join(';')
        },
        categoryChange(val) {
            this.form.details = []
            if (this.form.warehouseId) {
                this.warehouseChange(this.form.warehouseId)
            }
        },
        billingLogoTypeChaneg(val) {
            this.form.details = []
            if (this.form.warehouseId) {
                this.warehouseChange(this.form.warehouseId)
            }

        },
        warehouseChange(val) {
            this.form.warehouseId = val
            this.form.snapshotTime = this.parseTime(new Date())
            let arr = this.STATIC_Warehouses.filter(item => item.id == val)
            this.form.warehouseName = arr[0].name
            this.form.warehouseCategoryName = arr[0].category == 1 ? '一级库房' : '二级库房'
            this.form.warehouseCategory = arr[0].category
            this.getLocations(val)
            this.getProductList('')

            this.loading = true
            this.form.details = []
            // 是否存在未完成的科室入库 针对二级库
            if (arr[0].category == 2 && this.form.stockCategory == 0) {
                let query1 = {
                    applyDeptIds: arr[0].deptIds,
                    InStockStatus: 0,
                    "pageSize": 10,
                    "pageIndex": 1,
                    status: 2,
                }
                GetApplyOutStocks(query1).then(res => {
                    if (res.returnData.data && res.returnData.data.length > 0) {
                        this.$my_confirm("存在科室入库未完成，请完成入库后再盘点", "提示", {
                            confirmButtonText: "我知道了",
                            closeOnClickModal: false,
                            showCancelButton: false,
                            type: "warning",
                        }).then(() => {

                            // this.$route.params = { backAppointPage: 1 }
                            // 返回指定页
                            this.$router.push({
                                name: "Inventory",
                                params: {
                                    backAppointPage: 1
                                }
                            });
                        })
                    }
                })
            }

            // 带出库存明细
            let query = {
                "pageSize": 5000,
                "pageIndex": 1,
                stockCategory: this.form.stockCategory,
                warehouseId: this.form.warehouseId,
                billingLogoType: this.form.billingLogo,
                // loginDeptId: this.mySessionStorage.getDeptId(),
                loginWarehouseId: this.mySessionStorage.getWarehouseId()
            }

            GetInvertoryStock(query)
                .then(res => {
                    this.loading = false
                    if (!res.successful) {
                        return
                    }
                    this.details = []
                    this.dimensionDetails = []
                    this.form.details = []
                    if (res.returnData.data && res.returnData.data.length > 0) {
                        var details = res.returnData.data //.sort(this.compare)

                        details.map((item, index) => {
                            var detail = {}
                            // detail = this.mapper.Stock2Form(detail, item)
                            detail = Object.assign(detail, item)
                            detail.stockNumber = item.stockQuantity
                            if (this.system_setting.IsDefaultStocktakeNum) {
                                detail.inventoryNumber = item.stockQuantity
                            } else {
                                detail.inventoryNumber = 0
                            }
                            detail.diffNumber = detail.inventoryNumber - item.stockQuantity
                            detail.amount = (detail.price * detail.inventoryNumber).toFixed(4) * 1; //this.accMul(detail.price, detail.inventoryNumber)
                            detail.result = detail.inventoryNumber == 0 ? '盘亏' : '正常'
                            detail.$index = index + 1
                            detail.remark = ''
                            this.details.push(detail)
                        })
                        this.getDimensionDetails()

                        if (this.form.dimension == 1) {
                            this.form.details = this.dimensionDetails
                        } else {
                            this.form.details = this.details
                        }
                        this.autoTotalAmount()
                    }
                })

        },
        tagCodeView(row) {

            GetTagCodeList({
                stockIds: row.stockIds,
                pageSize: 999
            }).then((res) => {
                this.labelDetailsVisible = true;
                this.labelScanTagCodeIds = row.scanTagCodeIds?.split(',') || []
                this.labelDetailsData = res.returnData;
                console.log(this.labelScanTagCodeIds);

            });

        },
        productChange(row) {
            let id = this.childForm.id
            // let arr = this.STATIC_ApplySupplierProducts.filter((item) => item.id == row.id)
            this.childForm = Object.assign(this.childForm, row) // this.mapper.SupplierProduct2Form(this.childForm, arr[0])
            this.childForm.id = id
            if (!this.editMode) {
                this.childForm.supplierProductId = row.id
                this.childForm.price = row.purchasePrice
                this.childForm.number = 0
                this.childForm.supplierProductNo = row.no
                this.childForm.stockNumber = 0
            } else {
                this.childForm.stockNumber = row.stockQuantity
            }
            // this.childForm.supplierProductId = row.id
            this.childForm.inventoryNumber = row.stockQuantity
            this.childForm.diffNumber = 0
            // this.childForm.number = 1
            // this.childForm.price = this.childForm.billingPrice
            // this.childForm.purchasePrice = this.childForm.price
            this.childForm.amount = this.childForm.price
            this.childForm.remark = ''

            var that = this

            setTimeout(function () {
                that.$refs.number.focus()
                that.$refs.number.select()
            }, 1)

            this.$refs.childForm.validateField('productName')
        },

        getProductList(keyWord) {
            // query.pageSize = 50
            // query.pageIndex = 1
            // query.category = this.form.stockCategory
            // query.warehouseId = this.form.warehouseId

            let query = {}

            if (!this.editMode) {
                query = {

                    // userId: this.storage.getItem('user').id,
                    "pageSize": 20,
                    "pageIndex": 1,
                    "keyWord": keyWord,
                    // category: this.form.stockCategory,
                    warehouseId: this.form.warehouseId,
                    IsEnabledTempPurchaseGroup: 1,
                    billingLogo: this.form.billingLogo,
                }
                this.getSupplierProducts(query)

            } else {

                query = {
                    // userId: this.storage.getItem('user').id,
                    "pageSize": 20,
                    "pageIndex": 1,
                    "keyWord": keyWord,
                    stockCategory: this.form.stockCategory,
                    warehouseId: this.form.warehouseId,
                    billingLogoType: this.form.billingLogo,
                }
                this.getInvertoryStock(query)
                // this.getStocks(query)
            }

        },
        changeNumber(row) {
          this.details.forEach((item) => {
               if (item.mainNo == row.mainNo && item.traceNo == row.traceNo && item.supplierProductId == row.supplierProductId&&item.batch == row.batch&&item.manufactureDate == row.manufactureDate&&item.validityDate == row.validityDate) {

                // item.inventoryNumber = row.inventoryNumber
                this.$set(item, 'inventoryNumber', row.inventoryNumber)
                this.$set(item, 'diffNumber', item.inventoryNumber - item.stockNumber)
                this.$set(item, 'amount', (item.price * item.inventoryNumber).toFixed(4) * 1)
                this.$set(item, 'result', item.diffNumber < 0 ? '盘亏' : item.diffNumber > 0 ? '盘盈' : '正常')
               }
          })
          this.$set(row, 'diffNumber', row.inventoryNumber - row.stockNumber)
          this.$set(row, 'amount', (row.price * row.inventoryNumber).toFixed(4) * 1)
          this.$set(row, 'result', row.diffNumber < 0 ? '盘亏' : row.diffNumber > 0 ? '盘盈' : '正常')
            // row.diffNumber = row.inventoryNumber - row.stockNumber
            // row.amount = (row.price * row.inventoryNumber).toFixed(4) * 1; //this.accMul(row.price, row.inventoryNumber)
            // row.result = row.inventoryNumber == 0 ? '盘亏' : '正常'
            this.autoTotalAmount()
            this.$forceUpdate()
        },
        getInvertoryStock: Debounce(function (query) {
            GetInvertoryStock(query).then(res => {
                this.STATIC_Stocks = res.returnData.data;
            })
        }, 500),
        tagCodeChange(val) {
            if (!val) {
                return;
            }
            if (!this.form.warehouseId) {
                this.$my_message('请选择盘点仓库后扫码', 'warning')
                return
            }
            let data = {
                minTagCode: val,
                inOutType: 1,
                warehouseId: this.form.warehouseId,

            }
            GetStockInfoByTagCode(data).then(res => {
                res.returnData.forEach((item) => {
                    const matchedDetail = this.form.details.find(detail => {
                        if (!detail.tagCodeIds || !item.id) return false;
                        const tagCodeIdsArray = detail.tagCodeIds.split(',');
                        return tagCodeIdsArray.includes(item.id.toString());
                    });
                    if (matchedDetail) {
                        // 新增校验逻辑
                        let scanTagCodeIds = matchedDetail.scanTagCodeIds?.split(',') || [];
                        if (scanTagCodeIds.includes(item.id.toString())) {
                            this.$my_message('该标签已扫描过，请勿重复扫描', 'warning');
                            return;
                        }
                        matchedDetail.inventoryNumber = (matchedDetail.inventoryNumber || 0) + item.number;
                        matchedDetail.amount = (matchedDetail.inventoryNumber * matchedDetail.price).toFixed(4) * 1;
                        matchedDetail.diffNumber = matchedDetail.inventoryNumber - matchedDetail.stockNumber;
                        matchedDetail.result = matchedDetail.diffNumber < 0 ? '盘亏' : matchedDetail.diffNumber > 0 ? '盘盈' : '正常'
                        scanTagCodeIds.push(item.id)
                        scanTagCodeIds = [...new Set(scanTagCodeIds)]
                        matchedDetail.scanTagCodeIds = scanTagCodeIds.join(',')
                        // 找到匹配项后的处理逻辑
                        this.tagCode = ''
                    } else {
                        this.$my_message('此标签未匹配到盘点库存明细', 'warning')
                        return
                    }
                })

                this.autoTotalAmount()

            })
        },
        closeLabelDetailsDialog() {
            this.labelDetailsVisible = false
            this.labelDetailsData = {}
        },
        fillNumber() {
            if (this.form.dimension == 1) {
                this.details.forEach((item) => {
                    if (item.hasTagCode == 0) {
                        item.inventoryNumber = item.stockNumber
                        item.diffNumber = 0
                        item.amount = (item.inventoryNumber * item.price).toFixed(4) * 1;
                        item.result = '正常'
                    }
                })
            }
            this.form.details.forEach((item) => {
                if (item.hasTagCode == 0) {
                    item.inventoryNumber = item.stockNumber
                    item.diffNumber = 0
                    item.amount = (item.inventoryNumber * item.price).toFixed(4) * 1;
                    item.result = '正常'
                }
            })
            this.details.forEach((item) => {
                if (item.hasTagCode == 0) {
                    item.inventoryNumber = item.stockNumber
                    item.diffNumber = 0
                    item.amount = (item.inventoryNumber * item.price).toFixed(4) * 1;
                    item.result = '正常'
                }
            })
            this.autoTotalAmount()
        },

        dimensionChange(row) {
            this.dimensionData = row
            let data = {
                data: []
            }
            const mergedSerialMap = {};
            this.details.forEach((item) => {
                if (row.supplierProductNo == item.supplierProductNo && row.batch == item.batch && row.price == item.price) {
                    const serialNo = item.serialNo;
                    if (serialNo) {
                        if (mergedSerialMap[serialNo]) {
                            mergedSerialMap[serialNo].stockNumber = (mergedSerialMap[serialNo].stockNumber || 0) + (item.stockNumber || 0);
                            mergedSerialMap[serialNo].diffNumber = (mergedSerialMap[serialNo].diffNumber || 0) + (item.diffNumber || 0);
                        } else {
                            mergedSerialMap[serialNo] = JSON.parse(JSON.stringify(item));
                        }
                    } else {

                        data.data.push(JSON.parse(JSON.stringify(item)));
                    }
                }
            });

            // 将合并后的项添加到data.data
            data.data = data.data.concat(Object.values(mergedSerialMap));
            this.individualData = data
            this.individualVisible = true;
        },
        closeIndividualDialog() {
            this.individualVisible = false
            this.individualData = {}
        },
        addDetails(row) {
            // 定义唯一标识判断函数
            const isSameItem = (item) => {
                return item.supplierProductNo === row.supplierProductNo &&
                    item.batch === row.batch &&
                    item.price === row.price &&
                    item.serialNo === row.serialNo
            };

            const detailIndex = this.details.findIndex(isSameItem);
            if (detailIndex !== -1) {
                this.details.splice(detailIndex, 1, { ...row });
            } else {
                this.details.push({ ...row });
            }

            this.form.details.forEach((item) => {
                if (item.supplierProductNo === row.supplierProductNo &&
                    item.batch === row.batch &&
                    item.price === row.price) {
                    }
            })
         

        },
        delDetails(row) {
            const isSameItem = (item) => {
                return item.supplierProductNo === row.supplierProductNo &&
                    item.batch === row.batch &&
                    item.price === row.price &&
                    item.serialNo === row.serialNo;
            };
            const detailIndex = this.details.findIndex(isSameItem);
            if (detailIndex !== -1) {
                this.details.splice(detailIndex, 1);
            }

            const formDetailIndex = this.form.details.findIndex(isSameItem);
            if (formDetailIndex !== -1) {
                this.form.details.splice(formDetailIndex, 1);
            }
            this.getDimensionDetails()
        },
        confirmIndividualDialog(arr) {
            let num = 0
            arr.forEach(item => {
                num += Number(item.actualQuantity)
            })

            if (num != this.dimensionData.inventoryNumber) {
                this.$my_message('请输入实际数量与明细数量一致', 'warning')
                return
            }
            this.childForm = this.dimensionData
            arr.forEach(item => {
                item.inventoryNumber = item.actualQuantity

                this.autoDetails(item)
            })
            // this.pushChildForm(true)
            this.individualVisible = false
        }
    },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
    overflow: auto !important;
}

/deep/.el-input-number .el-input__inner {
    text-align: left !important;
}
</style>
